export { default as Img200 } from './processed/200/Braven.jpg';
export { default as Img400 } from './processed/400/Braven.jpg';
export { default as Imgthumb } from './processed/thumb/Braven.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Braven.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Braven.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      145,
      64,
      57
    ],
    "_population": 2201,
    "_hsl": [
      0.013257575757575751,
      0.43564356435643564,
      0.396078431372549
    ]
  },
  "LightVibrant": {
    "_rgb": [
      244,
      236,
      220
    ],
    "_population": 15,
    "_hsl": [
      0.1111111111111111,
      0.5217391304347831,
      0.9098039215686275
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      95,
      42,
      37
    ],
    "_population": 0
  },
  "Muted": {
    "_rgb": [
      126,
      123,
      129
    ],
    "_population": 2472,
    "_hsl": [
      0.7500000000000001,
      0.02380952380952378,
      0.49411764705882355
    ]
  },
  "LightMuted": {
    "_rgb": [
      193,
      200,
      208
    ],
    "_population": 2545,
    "_hsl": [
      0.5888888888888889,
      0.13761467889908258,
      0.7862745098039216
    ]
  },
  "DarkMuted": {
    "_rgb": [
      81,
      62,
      68
    ],
    "_population": 859,
    "_hsl": [
      0.9473684210526315,
      0.13286713286713284,
      0.2803921568627451
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Braven.js